import { IMeetingChangeset } from '../abstract-meeting-changeset';
import { IControlMeetingDetailsDTO } from '../../../api/control.dao';
import { IOperatorDetailsDTO } from '../../../api/rooms.dao';
import { MeetingOperatorsEventBody, SyncOperatorDetails } from '../index';

export class OperatorsAddedToTheMeeting extends IMeetingChangeset<MeetingOperatorsEventBody> {
    public applyChangesToMeeting(meeting: Partial<IControlMeetingDetailsDTO>): Partial<IControlMeetingDetailsDTO> {
        this.addOperatorsToMeeting(meeting);
        return meeting;
    }

    public getMeetingId(): number {
        return super.getChangeset().meetingId;
    }

    private addOperatorsToMeeting(meeting: Partial<IControlMeetingDetailsDTO>): void {
        const addedOperators = this.syncedOperators.map(this.syncedOperatorToMeetingOperator);
        meeting.operators = (meeting.operators || []).concat(addedOperators);
    }

    private get syncedOperators(): SyncOperatorDetails[] {
        return super.getChangeset().operators;
    }

    private syncedOperatorToMeetingOperator(operator: SyncOperatorDetails): IOperatorDetailsDTO {
        const { status, role, ..._operator } = operator;
        const operatorDetails = { ..._operator } as IOperatorDetailsDTO;
        operatorDetails.operatorRole = role || null;
        operatorDetails.operatorStatus = status;

        return operatorDetails;
    }
}
